// extracted by mini-css-extract-plugin
module.exports = {"type":"Type_type__3WOUQ"};